export default {
  'applink.title': 'Redireccionandote a la página en 5 segundos...'
}
